import { api, postUrl } from "./base";

const postForm = async (formId: string, data: any) => {
  const url = postUrl(formId);
  return await api.post(url, { response: JSON.stringify(data) });
};

const getForm = async (
  formId: string,
  pin: string | undefined
): Promise<any> => {
  if (pin) {
    return api.get<any>(formId, {
      headers: { "X-Form-AccessCode": pin }
    });
  }
  return api.get<any>(formId);
};

const getFormFieldData = async (
  formId: string,
  fieldId: string
): Promise<any> => {
  return api.get(`${formId},${fieldId}`);
};

interface DocumentDownloadData {
  blobUrl: string;
  suggestedPollPeriodSeconds: number;
  timeOutPeriodSeconds: number;
}

const getDocumentDownloadData = async (
  formId: string
): Promise<DocumentDownloadData> => {
  return api.get(`downloadInfo/${formId}`);
};

export { getForm, postForm, getFormFieldData, getDocumentDownloadData };
export type { DocumentDownloadData };
